// components/product/ProductInfo.jsx
import React from 'react';
import { FiSmartphone } from 'react-icons/fi';

const ProductInfo = ({ title, isDarkMode }) => {
  return (
    <>
      <div className="mb-4 sm:block">
        <div className="flex items-center gap-2 mb-2">
          <FiSmartphone className={isDarkMode ? 'text-emerald-400' : 'text-emerald-500'} size={20} />
          <h1 className={`text-md font-bold md:text-2xl ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Sell {title}
          </h1>
        </div>
        <p className={`text-xs md:text-sm flex items-center gap-1 ${
          isDarkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          Sell your device and get the best value instantly
        </p>
      </div>
    </>
  );
};

export default ProductInfo;